import React from "react";

const EmbarkContent = ({content}) => {
  return (
    <section className="keyzi_mind--wrapper keyzi_unlockContent--wrapper">
      <div className="container">
        <div className="keyzi_mind--inner">
          {content?.[0]?.description && <div dangerouslySetInnerHTML={{ __html: content?.[0]?.description }} /> }
        </div>
      </div>
    </section>
  );
};

export default EmbarkContent;
